import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrivateSpaceComponent } from './private-space.component';
import { ViewValuationRequestsComponent } from './valuation-requests/view-valuation-requests/view-valuation-requests.component';
import { ValuationsComponent } from './valuations/valuations.component';
import { ViewSponsorshipRequestsComponent } from './sponsorship-requests/view-sponsorship-requests/view-sponsorship-requests.component';
import { SporsorshipsComponent } from './sporsorships/sporsorships.component';
import { ViewPropertiesComponent } from './properties/view-properties/view-properties.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddPropertyComponent } from './properties/add-property/add-property.component';
import { AddValuationRequestsComponent } from './valuation-requests/add-valuation-requests/add-valuation-requests.component';
import { AddSponsorshipRequestsComponent } from './sponsorship-requests/add-sponsorship-requests/add-sponsorship-requests.component';
import { EditPropertyComponent } from './properties/edit-property/edit-property.component';
import { ViewSinglePropertyComponent } from './properties/view-single-property/view-single-property.component';
import { EditSponsorshipRequestComponent } from './sponsorship-requests/edit-sponsorship-request/edit-sponsorship-request.component';
import { ViewSingleSponsorshipRequestComponent } from './sponsorship-requests/view-single-sponsorship-request/view-single-sponsorship-request.component';
import { EditValuationRequestComponent } from './valuation-requests/edit-valuation-request/edit-valuation-request.component';
import { ViewSingleValuationRequestComponent } from './valuation-requests/view-single-valuation-request/view-single-valuation-request.component';

const routes: Routes = [
  { 
    path: '', 
    component: PrivateSpaceComponent,
    data: {
      title: 'private-space',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'view',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          title: 'Dashboard',
        },
      },
      {
        path: 'view-properties',
        component: ViewPropertiesComponent,
        data: {
          title: 'Properties',
        },
      },
      {
        path: 'add-property',
        component: AddPropertyComponent,
        data: {
          title: 'Properties',
        },
      },
      {
        path: 'edit-property',
        component: EditPropertyComponent,
        data: {
          title: 'Properties',
        },
      },
      {
        path: 'view-single-property',
        component: ViewSinglePropertyComponent,
        data: {
          title: 'Properties',
        },
      },
      {
        path: 'view-sporsorship-requests',
        component: ViewSponsorshipRequestsComponent,
        data: {
          title: 'Sporsorship Requests',
        },
      },
      {
        path: 'add-sporsorship-requests',
        component: AddSponsorshipRequestsComponent,
        data: {
          title: 'Request a sponsorship',
        },
      },
      {
        path: 'edit-sporsorship-request',
        component: EditSponsorshipRequestComponent,
        data: {
          title: 'Request a sponsorship',
        },
      },
      {
        path: 'view-single-sporsorship-request',
        component: ViewSingleSponsorshipRequestComponent,
        data: {
          title: 'Request a sponsorship',
        },
      },
      {
        path: 'view-sporsorships',
        component: SporsorshipsComponent,
        data: {
          title: 'Sporsorships',
        },
      },
      {
        path: 'view-valuation-requests',
        component: ViewValuationRequestsComponent,
        data: {
          title: 'view valuation requests',
        },
      },
      {
        path: 'add-valuation-requests',
        component: AddValuationRequestsComponent,
        data: {
          title: 'Request a valuation',
        },
      },
      {
        path: 'edit-valuation-request',
        component: EditValuationRequestComponent,
        data: {
          title: 'Edit a Valuation Request',
        },
      },
      {
        path: 'view-single-valuation-request',
        component: ViewSingleValuationRequestComponent,
        data: {
          title: 'View a Valuation Request',
        },
      },
      {
        path: 'view-valuations',
        component: ValuationsComponent,
        data: {
          title: 'Valuations',
        },
      }
    ]
   }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrivateSpaceRoutingModule { }
